import { render, staticRenderFns } from "./CreateOrder.vue?vue&type=template&id=0f75c65c&"
import script from "./CreateOrder.vue?vue&type=script&lang=js&"
export * from "./CreateOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreateOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QList,QExpansionItem,QCard,QCardSection,QSelect,QItem,QItemSection,QTable,QTr,QTd,QBtn,QPopupEdit,QInput,QIcon,QPopupProxy,QDate,QSpinnerHourglass} from 'quasar'
component.options.components = Object.assign({QPage,QList,QExpansionItem,QCard,QCardSection,QSelect,QItem,QItemSection,QTable,QTr,QTd,QBtn,QPopupEdit,QInput,QIcon,QPopupProxy,QDate,QSpinnerHourglass}, component.options.components || {})
